import { render, staticRenderFns } from "./learning_main.vue?vue&type=template&id=77707354&scoped=true&"
import script from "./learning_main.vue?vue&type=script&lang=js&"
export * from "./learning_main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77707354",
  null
  
)

export default component.exports